import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AuthorComposerPublicView } from "./AuthorComposerPublicView";
import { AuthorComposerViewStore } from "../../store/AuthorComposerViewStore";
import { useStore } from "../../../../hooks";
import { authorComposerPublicService } from "../../services/authorComposerPublicService";

export const AuthorComposerPublicViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/author-composer-public/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AuthorComposerViewStore(rootStore);
      // Proyección: cargar por el documento de la proyección (solo sus campos)
      // en vez del de la entidad — que puede pedir refs que este rol no puede
      // leer (p.ej. CreditPurchase.tenant para un SiteAdmin). Solo se overridea
      // getOne: es lo único que usa el view y sus tipos coinciden.
      s.service = { ...s.service, getOne: authorComposerPublicService.getOne };
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "personalInformation",
              label:
                rootStore.langStore
                  .groupAuthorComposerPublicPersonalInformationLabel,
            },
            {
              id: "address",
              label: rootStore.langStore.groupAuthorComposerPublicAddressLabel,
            },
            {
              id: "professionalInformation",
              label:
                rootStore.langStore
                  .groupAuthorComposerPublicProfessionalInformationLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AuthorComposerPublicView authorComposerViewStore={store} />
      </PageLayout>
    </div>
  );
});
